/* Barre du panier : la livraison offerte, acquise d'office.
   Barre pleine + coche, comme l'etat "debloque" de l'ancienne barre d'offre. */
(() => {
  const ID = "svl-offer-bar";
  const L = window.SVL_I18N || {};

  const CHECK_ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  const BANNER =
    '<div class="svcb"><span class="svcb__t">' + (L.lastHours || "<b>Last hours</b> &middot; offer ends at midnight") + '</span></div>';

    /* 🔴 28/09 : la barre "livraison offerte" est RETIREE a la demande de Lucas.
     Elle apparaissait puis disparaissait au re-rendu du tiroir et faisait perdre
     confiance. Seul le bandeau d'offre reste. Pour la remettre un jour :
     reintroduire le bloc .svop ci-dessous dans markup(). */
  const markup = () => BANNER;



  /* ---- bandeau de reassurance, en pied de panier ---- */
  const USP_ID = "svl-cart-usp";
  const ICON = {
    warranty: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l1.9 4.3 4.6.5-3.4 3.1.9 4.6L12 13.2 8 15.5l.9-4.6L5.5 7.8l4.6-.5z"/></svg>',
    water:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3s6 6.6 6 10.4A6 6 0 0 1 6 13.4C6 9.6 12 3 12 3z"/></svg>',
    returns:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12a8 8 0 1 1-2.5-5.8"/><path d="M20 4v4h-4"/></svg>'
  };
  const USP = [
    ["warranty", L.uspWarrantyT || "1 year", L.uspWarrantyD || "Warranty"],
    ["water",    L.uspWaterT || "Water-resistant", L.uspWaterD || "Won\u2019t tarnish"],
    ["returns",  L.uspReturnsT || "30 days", L.uspReturnsD || "Easy returns"]
  ];
  function paintUsp() {
    document.querySelectorAll("#" + USP_ID).forEach((n) => n.remove());
    /* le bloc des moyens de paiement vit HORS de .cart-drawer__footer :
       on le cherche dans le tiroir ou dans le pied de la page panier, jamais dans le footer du site */
    const scope = document.querySelector("cart-drawer")
               || document.querySelector("#main-cart-footer")
               || document.querySelector(".cart__footer");
    if (!scope) return;
    const pay = scope.querySelector(".footer__payment, [class*='list-payment']");
    const foot = scope.querySelector(".cart-drawer__footer") || scope;
    const el = document.createElement("div");
    el.id = USP_ID;
    el.innerHTML = '<ul class="svu">' + USP.map(([k, t, d]) =>
      '<li class="svu__i"><span class="svu__ic">' + ICON[k] + '</span>' +
      '<span class="svu__t"><b>' + t + '</b><i>' + d + '</i></span></li>').join("") + "</ul>";
    if (pay) {
      const bloc = pay.classList.contains("footer__payment") ? pay : (pay.closest(".footer__payment") || pay);
      bloc.parentElement.insertBefore(el, bloc.nextSibling);   /* juste APRES les icones */
    } else {
      foot.appendChild(el);
    }
  }

  async function paint() {
    let cart;
    try { cart = await fetch("/cart.js").then((r) => r.json()); } catch (e) { return; }
    document.querySelectorAll("#" + ID).forEach((n) => n.remove());
    if (cart.item_count === 0) return;
    const host =
      document.querySelector("cart-drawer .drawer__inner") ||
      document.querySelector(".cart__items") ||
      document.querySelector("#main-cart-items");
    if (!host) return;

    const el = document.createElement("div");
    el.id = ID;
    el.innerHTML = markup();
    /* 🔴 ORDRE IMPOSE (Lucas, 28/09) : le timer de reservation en PREMIER, le bandeau
       d'offre juste en dessous. Les deux scripts visaient "apres le header" : l'ordre
       dependait de qui s'executait en dernier. Ici on se cale explicitement sur le timer. */
    const timer  = host.querySelector(".elora-rsv");
    const header = host.querySelector(".drawer__header");
    if (timer) timer.after(el);
    else if (header) header.after(el);
    else host.prepend(el);
    paintUsp();
  }

  const later = () => setTimeout(paint, 120);
  document.addEventListener("DOMContentLoaded", later);
  if (document.readyState !== "loading") later();
  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, later);
  }
  // le theme re-rend le tiroir sans toujours publier l'evenement
  const watch = () => {
    const d = document.querySelector("cart-drawer");
    if (!d) return setTimeout(watch, 500);
    new MutationObserver(() => {
      if (!document.getElementById(ID)) return later();
      /* le theme re-rend le PIED du tiroir sans toucher au haut : la barre survit, le bandeau
         de reassurance disparait. On le surveille separement, sinon plus rien ne le remet. */
      if (!document.getElementById(USP_ID)) setTimeout(paintUsp, 60);
    })
      .observe(d, { childList: true, subtree: true });
    later();
  };
  watch();
})();
